<template>
  <v-container fluid class="team-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/team/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              v-model="item_seleted"
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="teams-table"
              show-select
              single-select
              item-key="_id"
              sort-by="createdAt"
              sort-desc
              :footer-props="footer"
              :headers="team_headers"
              :items="teams"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteTeam"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Team?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_team.teamcode }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteTeam = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteTeam(delete_team)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.teamstatus="{ item }">
                <v-chip
                  :color="!item.teamstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.teamstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.updatedAt="{ item }">
                {{ new Date(item.updatedAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editTeam(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'TeamList',
  data() {
    return {
      isDeleteTeam: false,
      isLoading: false,
      delete_team: {},
      item_seleted: [],
      team_headers: [
        { text: 'Code', value: 'teamcode'},
        { text: 'Name', value: 'teamname'},
        { text: 'Type', value: 'teamtype'},
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
    }
  },
  computed: {
    ...mapState('Team', ['teams', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating']),
  },
  async created () {
    await this.getTeamsRequest();
  },
  methods: {
    ...mapActions('Team', ["deleteTeamRequest","getTeamsRequest"]),
    editTeam(item) {
      this.$router.push({name: 'TeamEdit', params: item});
    },
    deleteTeam(item) {
      this.deleteTeamRequest({_id: item._id});
      this.isDeleteTeam = false;
    },
    deleteDialog(item) {
      this.isDeleteTeam = true;
      this.delete_team = {_id: item._id,teamcode: item.teamcode};
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
